/** @jsxImportSource minimal-view */

import { Component, View, part } from 'minimal-view'
import { IS_PROD, IS_TEST } from './env'

const observers: Map<string, Set<(nonce: number) => void>> = new Map()

export function hmr<T>(c: T): T
export function hmr<T extends Component<any, any, any>>(importUrl: string, c: T): T
export function hmr<T extends Component<any, any, any>>(importUrl: string, Comp?: T): T {
  if (!Comp || IS_TEST || IS_PROD) return importUrl as any
  if (importUrl.includes('hmr,')) return Comp

  const url = new URL(importUrl)

  observers.set(url.pathname, new Set())

  const fn = ((props: any) => {
    let currentProps: any
    let update: any
    const View = part((_update) => {
      update = _update
      const load = async (nonce: number) => {
        const mod = await Promise.race([
          new Promise((_, reject) => setTimeout(reject, 1500, new Error('Timed out: ' + importUrl))
          ),
          import(url.href + "?hmr,nonce=" + nonce)
        ])
        console.log('component updated', importUrl)
        const moduleEntries = Object.entries(mod)
        // TODO: use heuristics to determine component export
        Comp = moduleEntries[0][1] as any
        Comp = Comp!
        update(<Comp {...currentProps} />)
      }
      observers.get(url.pathname)!.add(load)
    })
    currentProps = props
    Comp = Comp!
    update(<Comp {...currentProps} />)
    return <View />
  }) as unknown as T

  fn.toString = () => Comp!.toString()

  return fn
}

window.onmessage = ({ data }) => {
  if (data.type === 'update') {
    let didTrigger = false
    const nonce = Date.now()
    for (const pathname of data.payload) {
      [...(observers.get(pathname) ?? [])].forEach((fn) => {
        didTrigger = true
        fn(nonce)
      })
    }
    if (!didTrigger) {
      location.href = location.href
    }
  }
}
